import { useExternalChange } from "@/components/ContentArea/external-update-context";
import { useState } from "react";

const useFullscreen = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const { setExternalChangeInProcess } = useExternalChange();

  const setIsFullscreenWithExternalChange = (value: boolean) => {
    setExternalChangeInProcess?.(value);
    setIsFullscreen(value);
  };

  return {
    isFullscreen,
    setIsFullscreen: setIsFullscreenWithExternalChange,
    open: () => {
      setExternalChangeInProcess?.(true);
      setIsFullscreen(true);
    },
    close: () => {
      setIsFullscreen(false);
    },
  };
};

export default useFullscreen;
